import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { Loader2 } from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import { PROVIDER_NAMES } from "@/components/settings/data-providers/constants";
import { AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { TOUR_TARGETS } from "@/features/onboarding-tours/orchestrator/tour-target-ids";
import { useCurrentWorkspace } from "@/hooks/useCurrentWorkspace";
import { useDataProviders } from "@/hooks/useDataProviders";
import { emitter, type SettingsDataProviderEmitterState } from "@/lib/emitter";
export function controlDeleteDataProvider(properties: SettingsDataProviderEmitterState) {
  emitter.emit("settings.workspace.data_provider.delete", properties);
}
export function DeleteDataProvider() {
  const $ = _c(27);
  const {
    workspaceId
  } = useCurrentWorkspace();
  const [providerId, setProviderId] = useState(null);
  const [isOpen, setOpenState] = useState(false);
  const {
    deleteWorkspaceDataProvider,
    deletingWorkspaceDataProvider: isDeleting,
    dataProviders
  } = useDataProviders();
  const selectedProvider = dataProviders.find(provider => provider.id === providerId);
  let t0;
  if ($[0] !== deleteWorkspaceDataProvider || $[1] !== providerId || $[2] !== workspaceId) {
    t0 = async () => {
      if (providerId) {
        await deleteWorkspaceDataProvider({
          providerId,
          workspaceId
        });
      }
    };
    $[0] = deleteWorkspaceDataProvider;
    $[1] = providerId;
    $[2] = workspaceId;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleDelete = t0;
  let t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      emitter.on("settings.workspace.data_provider.delete", t3 => {
        const {
          data,
          state
        } = t3;
        setOpenState(state === "on");
        if (!data.providerId) {
          setTimeout(() => {
            setProviderId(data.providerId);
          }, 300);
        } else {
          setProviderId(data.providerId);
        }
      });
      return () => {
        emitter.off("settings.workspace.data_provider.delete", () => {
          setProviderId(null);
          setOpenState(false);
        });
      };
    };
    t2 = [];
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = open => {
      if (!open) {
        setProviderId(null);
        controlDeleteDataProvider({
          data: {
            providerId: null
          },
          state: "off"
        });
      }
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <AlertDialogTitle>Delete Data Provider</AlertDialogTitle>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = PROVIDER_NAMES[selectedProvider?.type || ""];
  let t6;
  if ($[8] !== t5) {
    t6 = <AlertDialogHeader>{t4}<AlertDialogDescription>Are you sure you want to delete the{" "}<span className="font-bold">{t5}</span>{" "}data provider? This action cannot be undone.</AlertDialogDescription></AlertDialogHeader>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== isDeleting) {
    t7 = <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>;
    $[10] = isDeleting;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isDeleting) {
    t8 = isDeleting ? <><Loader2 className="size-4 animate-spin" />Deleting...</> : "Delete";
    $[12] = isDeleting;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== handleDelete || $[15] !== isDeleting || $[16] !== t8) {
    t9 = <Button className="bg-destructive text-destructive-foreground hover:bg-destructive/90" disabled={isDeleting} id={TOUR_TARGETS.dataProviderDeleteSubmit} onClick={handleDelete}>{t8}</Button>;
    $[14] = handleDelete;
    $[15] = isDeleting;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t9) {
    t10 = <AlertDialogFooter>{t7}{t9}</AlertDialogFooter>;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t6) {
    t11 = <AlertDialogContent id={TOUR_TARGETS.dataProviderDeleteConfirm}>{t6}{t10}</AlertDialogContent>;
    $[21] = t10;
    $[22] = t6;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== isOpen || $[25] !== t11) {
    t12 = <AlertDialog onOpenChange={t3} open={isOpen}>{t11}</AlertDialog>;
    $[24] = isOpen;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
}